"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _components = require("../../components");
var _utils = require("../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var onAmazonClick = function onAmazonClick() {
  return window.open('https://pharmacy.amazon.com', '_blank');
};
var MedicationActions = function MedicationActions(_ref) {
  var pharmacy = _ref.pharmacy,
    isPatient = _ref.isPatient,
    pharmacyFetchError = _ref.pharmacyFetchError;
  var isAmazon = !!pharmacy && pharmacy.pharmacyId.toString() === process.env.REACT_APP_DOSESPOT_ID_FOR_AMAZON;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-medication-actions text-black"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-subtitle-sm-medium "
  }, isPatient ? 'Your prescription has been sent.' : 'Prescription sent to:'), pharmacyFetchError ? /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-label-sm-regular text-alertred-60 mt-[16px]"
  }, "Pharmacy information missing! Please check if the pharmacy still exists.") : (0, _lodash.isEmpty)(pharmacy) ? /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-label-sm-regular mt-[16px]"
  }, "No pharmacy selected.") : isAmazon ? isPatient ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-description-light mt-[8px]"
  }, "Visit Amazon Pharmacy to confirm and complete."), /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    className: "mt-[16px]",
    size: "large",
    onClick: onAmazonClick
  }, "Get my prescription")) : /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-label-sm-regular mt-[16px]"
  }, "Amazon Pharmacy") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isPatient && /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-description-light mt-[8px]"
  }, "Visit your local pharmacy to receive your medication."), /*#__PURE__*/_react.default.createElement("address", {
    className: "m-0 tw-label-light mt-[16px] flex flex-col gap-y-[8px]"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-label-regular"
  }, pharmacy.storeName), /*#__PURE__*/_react.default.createElement("div", null, pharmacy.address1), /*#__PURE__*/_react.default.createElement("div", null, pharmacy.city, ", ", pharmacy.state, " ", pharmacy.zipCode)), /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    className: "mt-[24px]",
    size: "large",
    url: "tel:".concat(pharmacy.primaryPhone)
  }, (0, _utils.formatPhoneNumber)(pharmacy.primaryPhone))));
};
var _default = MedicationActions;
exports.default = _default;